import React from "react";
import { Container, ImageWrap, Inner, Section } from "./styles";
import { Typo } from "../../../../../../layout/theme";
import Image from "../../../../../../common/image/Image";

export default function ProductCard({ product }) {
	return (
		<Inner>
			<ImageWrap>
				<Image src={product.photoUrl} width={42} />
			</ImageWrap>

			<Container>
				<Section>
					<Typo type="primary" level={7} style={{ fontWeight: 700 }}>
						{product.title}
					</Typo>
				</Section>

				<Section>
					<Typo type="muted" level={7}>
						{product.presentationName}
					</Typo>
				</Section>

				<Section>
					<Typo type="muted" level={7}>
						{product.ean13}
					</Typo>
					<Typo type="secondary" level={7}>
						Peso: {product.baseBoost}
					</Typo>
				</Section>
			</Container>
		</Inner>
	);
}
